import script from "./EditCourseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCourseForm.vue?vue&type=script&setup=true&lang=js"

import "./EditCourseForm.vue?vue&type=style&index=0&id=74fad033&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fad033"]])

export default __exports__